<template>
  <div class="info" :class="{ ['info--' + lang]: true }">
    <div class="info__container" ref="container">
      <div class="info__image" ref="info_image" v-view="viewHandlerImage">
        <img src="assets/img/pavilion-image.jpg" alt="" />

        <inline-svg
          class="info__bubble-decor"
          ref="bubble_decor"
          :src="require('@/assets/svg/decor-item-countdown.svg')"
        />
      </div>
      <div class="info__text" ref="text" v-view="viewHandlerText">
        <h3>{{ getText("info_kicker") }}</h3>
        <h1 v-html="getText('info_headline')"></h1>
        <p>
          {{ getText("info_copy") }}
        </p>

        <div class="info__text-block">
          <h4>{{ getText("info_block_headline") }}</h4>
          <span>{{ getText("info_block1_1") }}</span>
          <span>{{ getText("info_block1_2") }}</span>
        </div>

        <div class="info__text-block">
          <span>{{ getText("info_block2_1") }}</span>
          <span>{{ getText("info_block2_2") }}</span>
        </div>

        <span>{{ getText("info_link_headline") }}</span>
        <span class="bold"
          ><a :href="getText('info_link_url')" target="_blank"
            >{{ getText("info_link_label") }}
            <inline-svg :src="require('@/assets/svg/link-arrow.svg')"
          /></a>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import ContentMixin from "@/mixins/ContentMixin";
export default {
  name: "Info",
  mixins: [ContentMixin],
  props: {},
  data() {
    return {
      imageShown: false,
      textShown: false,
    };
  },
  computed: {
    screenWidth() {
      return this.$screen.width;
    },
  },
  watch: {
    lang() {
      this.$nextTick(() => {
        gsap.set(this.$refs.info_image, {
          marginLeft: "",
          marginRight: "",
        });

        this.resetView();
        this.setOverFill();
      });
    },
    textbooklet() {
      this.$nextTick(() => {
        this.resetView();
        this.setOverFill();
      });
    },
    screenWidth() {
      this.setOverFill();
    },
  },
  methods: {
    resetView() {
      this.imageShown = false;
      this.textShown = false;

      gsap.to(this.$refs.info_image, {
        duration: 0,
        y: 100,
        autoAlpha: 0,
      });

      gsap.to(this.$refs.text, {
        duration: 0,
        y: 100,
        autoAlpha: 0,
      });

      this.setOverFill();
    },
    viewHandlerImage(e) {
      if (this.imageShown) return;

      if (e.percentInView >= 0.125) {
        this.imageShown = true;
        gsap.to(this.$refs.info_image, { autoAlpha: 1 });
        gsap.to(this.$refs.info_image, {
          y: 0,
          duration: 1,
        });

        gsap.set(this.$refs.bubble_decor.$el, { top: 100, autoAlpha: 0 });
        gsap.to(this.$refs.bubble_decor.$el, { duration: 2, top: 0 });
        gsap.to(this.$refs.bubble_decor.$el, { autoAlpha: 1 });

        //gsap.set(this.$refs.image_decor.$el, { autoAlpha: 0 });
        //gsap.to(this.$refs.image_decor.$el, { delay: 1, autoAlpha: 1 });

        /*


        gsap.to(this.$refs.image_decor, { autoAlpha: 1 });
        gsap.to(this.$refs.image_decor, {
          y: 0,
          duration: 1,
        });

        gsap.to(this.$refs.bubble_decor, { autoAlpha: 1 });
        gsap.to(this.$refs.bubble_decor, {
          y: 0,
          duration: 1,
        });
        */
      }
    },
    viewHandlerText(e) {
      if (this.textShown) return;

      if (e.percentInView >= 0.125) {
        this.textShown = true;
        gsap.to(this.$refs.text, { autoAlpha: 1, y: 0 });
        gsap.to(this.$refs.text, { duration: 1, y: 0 });
      }
    },
    setOverFill() {
      const overfill = this.$refs.container.getBoundingClientRect().left;

      if (this.screenWidth > 1920) {
        gsap.set(this.$refs.info_image, {
          marginLeft: "",
          marginRight: "",
        });
      } else {
        if (this.lang === "en") {
          gsap.set(this.$refs.info_image, { marginLeft: -overfill + "px" });
        } else {
          gsap.set(this.$refs.info_image, { marginRight: -overfill + "px" });
        }
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.resetView();
      this.setOverFill();
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style></style>
